import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@workos-inc/authkit-react";
import { Box, CircularProgress } from "@mui/material";

/** Access requires any one of the supplied permissions. */
export function RequirePermission({
  permission,
  children,
}: {
  permission: string | string[];
  children: ReactNode;
}) {
  const { isLoading, permissions = [] } = useAuth();
  const required = Array.isArray(permission) ? permission : [permission];

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!required.some((p) => permissions.includes(p))) {
    return <Navigate to="/incidents" replace />;
  }

  return <>{children}</>;
}
